import { render, staticRenderFns } from "./ConservationPurposesForm.vue?vue&type=template&id=5b6d9862"
import script from "./ConservationPurposesForm.vue?vue&type=script&lang=js"
export * from "./ConservationPurposesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports